import { jsxs as B, Fragment as G, jsx as e } from "react/jsx-runtime";
import { Link as v } from "@tanstack/react-router";
import { useIsActiveRoute as T } from "../../../../hooks/use-is-active-route.js";
import { useLink as W } from "../../../../hooks/use-link.js";
import { useTranslate as A } from "../../../../hooks/use-translate.js";
import { makeClassesByStyles as F } from "../../../../utils/classes.js";
import { GradientBorderWrapper as H } from "../../../gradient-border-wrapper/gradient-border-wrapper.js";
import o from "../../../../assets/f1ac8584.button.module.css";
import { Image as R } from "../image/image.js";
import { InlineSvg as V } from "../inline-svg/inline-svg.js";
const i = F(o), x = (t) => t.endsWith(".svg"), Z = ({
  asset: t,
  className: h,
  children: I,
  color: n = "secondary",
  forceActive: N,
  href: s,
  isAccessible: m = !0,
  disabled: y = !1,
  size: c,
  styledAs: L = "link",
  target: $,
  text: r,
  notificationMarker: P,
  isExact: _,
  withGradientBorder: S = !1,
  borderRadius: l = "rounded-full",
  onClick: a,
  ...w
}) => {
  const C = A(), p = typeof s == "string", { linkItem: d, isExternal: g, target: E } = W({ href: s, onClick: a, target: $ }), j = T(p ? s : (s == null ? void 0 : s.href) ?? ""), u = {
    className: i(
      "Link",
      `--as-${L}`,
      `--${l}`,
      {
        "--active": !!N || j,
        [`--${n}`]: !!n,
        [`--${c}`]: !!c,
        "--with-image": !!t
      },
      h
    ),
    disabled: y,
    itemProp: "url",
    ...g && p && { href: s },
    ...g && { rel: "noopener noreferrer" },
    target: E,
    ...w
  }, k = i(o.asset, {
    "--with-text": !!r
  }), f = /* @__PURE__ */ B(G, { children: [
    !!t && x(t) && /* @__PURE__ */ e(V, { className: k, src: t }),
    !!t && !x(t) && /* @__PURE__ */ e(
      R,
      {
        className: k,
        alt: r ?? "",
        src: t,
        width: 32,
        height: 32
      }
    ),
    I ?? (r && /* @__PURE__ */ e("span", { className: o.text, children: C(r) })),
    P
  ] });
  return S ? /* @__PURE__ */ e(H, { color: n, borderRadius: l, children: /* @__PURE__ */ e(
    v,
    {
      "data-testid": "link",
      activeProps: { className: i("--active") },
      onClick: a,
      ...d,
      ...u,
      ...!m && { tabIndex: -1 },
      children: f
    }
  ) }) : /* @__PURE__ */ e(
    v,
    {
      "data-testid": "link",
      activeProps: { className: i("--active") },
      onClick: a,
      ...d,
      ...u,
      ...!m && { tabIndex: -1 },
      children: f
    }
  );
};
export {
  Z as Link
};
